<script lang="ts" setup>
import type { LinkNode } from '@laam/cms-shared';
import { LazyImage } from '../lazy-image';

interface EntityCardProps {
	data: LinkNode;
	entity: string;
}

defineProps<EntityCardProps>();
</script>
<template>
	<div
		class="rounded-xs image-box h-fit w-full !min-h-[100px] relative aspect-[5/7] bg-gray-100 overflow-clip"
	>
		<LazyImage
			v-if="data?.image"
			:src="data?.image"
			:alt="data.name"
			width="280"
			provider="shopify"
			class="rounded-small w-full"
		/>
	</div>

	<div class="flex mt-xl gap-md w-full">
		<div class="size-9xl rounded-small border border-gray-200 aspect-[1/1]">
			<NuxtImg :src="data.logo" class="w-full h-full" />
		</div>
		<div class="flex flex-col overflow-ellipsis">
			<h4 class="text-sm font-medium text-left text-gray-900 line-clamp-1">
				{{ data.name?.replace(/__/g, '') }}
			</h4>
			<text v-if="data.subtitle" class="text-sm text-left text-gray-700">
				{{ data.subtitle }}
			</text>
		</div>
	</div>
</template>
